
<div class="average-svg-container"  #averageBox>
    <svg class="average-box">
        <path class="average-box-body" [attr.d]="averageBoxPath" />
        <text class="text-avg" x="30" [attr.y]="TEXT_START_Y">AVG</text>
        <text class="avg-value" [ngClass]="className"  x="66" [attr.y]="TEXT_START_Y">{{average.toFixed(1)}}</text>
        <text x="88" class="total-value lato-12-n-vw" [attr.y]="TEXT_START_Y" >/{{total}}</text>
      </svg>
</div>